import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { DollarSign, TrendingUp, Users, Building2, Zap, Activity, AlertCircle, CheckCircle, Download, Eye, Server, Shield, Percent, Package, Truck } from 'lucide-react';
export function SuperAdminDashboard() {
  return <div className="space-y-6" data-id="element-2973">
      {/* Header */}
      <div className="flex items-start justify-between" data-id="element-2974">
        <div data-id="element-2975">
          <h2 className="text-3xl font-bold text-slate-900" data-id="element-2976">
            Platform Overview
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-2977">
            KDMP B2B Purchasing Platform - Revenue & Performance Analytics
          </p>
        </div>
        <div className="flex items-center gap-2 px-4 py-2 bg-green-50 border border-green-200 rounded-lg" data-id="element-2978">
          <Activity className="w-4 h-4 text-green-600 animate-pulse" data-id="element-2979" />
          <span className="text-sm font-bold text-green-700" data-id="element-2980">
            Platform Healthy
          </span>
        </div>
      </div>

      {/* Revenue Overview - Main KPIs */}
      <div className="grid grid-cols-4 gap-6" data-id="element-2981">
        <Card className="p-6 relative overflow-hidden bg-gradient-to-br from-blue-500 to-blue-600 text-white border-0 shadow-xl shadow-blue-200" data-id="element-2982">
          <div className="absolute top-0 right-0 w-32 h-32 opacity-10" data-id="element-2983">
            <DollarSign className="w-full h-full" data-id="element-2984" />
          </div>
          <div className="relative z-10" data-id="element-2985">
            <div className="flex items-center gap-3 mb-3" data-id="element-2986">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-2987">
                <DollarSign className="w-6 h-6 text-white" data-id="element-2988" />
              </div>
              <Badge className="bg-green-400 text-green-900 border-0" data-id="element-2989">
                <TrendingUp className="w-3 h-3 mr-1" data-id="element-2990" />
                +18%
              </Badge>
            </div>
            <p className="text-sm text-blue-100 mb-1" data-id="element-2991">
              Total Revenue (Bulan Ini)
            </p>
            <p className="text-4xl font-extrabold" data-id="element-2992">Rp 125Jt</p>
            <p className="text-xs text-blue-200 mt-2" data-id="element-2993">Target: Rp 150Jt</p>
          </div>
        </Card>

        <Card className="p-6 relative overflow-hidden bg-gradient-to-br from-green-500 to-green-600 text-white border-0 shadow-xl shadow-green-200" data-id="element-2994">
          <div className="absolute top-0 right-0 w-32 h-32 opacity-10" data-id="element-2995">
            <Zap className="w-full h-full" data-id="element-2996" />
          </div>
          <div className="relative z-10" data-id="element-2997">
            <div className="flex items-center gap-3 mb-3" data-id="element-2998">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-2999">
                <Zap className="w-6 h-6 text-white" data-id="element-3000" />
              </div>
              <Badge className="bg-green-400 text-green-900 border-0" data-id="element-3001">
                MRR
              </Badge>
            </div>
            <p className="text-sm text-green-100 mb-1" data-id="element-3002">Subscription Fee</p>
            <p className="text-4xl font-extrabold" data-id="element-3003">Rp 25Jt</p>
            <p className="text-xs text-green-200 mt-2" data-id="element-3004">PTX: Rp 25Jt/bulan</p>
          </div>
        </Card>

        <Card className="p-6 relative overflow-hidden bg-gradient-to-br from-violet-500 to-violet-600 text-white border-0 shadow-xl shadow-violet-200" data-id="element-3005">
          <div className="absolute top-0 right-0 w-32 h-32 opacity-10" data-id="element-3006">
            <Building2 className="w-full h-full" data-id="element-3007" />
          </div>
          <div className="relative z-10" data-id="element-3008">
            <div className="flex items-center gap-3 mb-3" data-id="element-3009">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-3010">
                <Building2 className="w-6 h-6 text-white" data-id="element-3011" />
              </div>
              <Badge className="bg-violet-300 text-violet-900 border-0" data-id="element-3012">
                Active
              </Badge>
            </div>
            <p className="text-sm text-violet-100 mb-1" data-id="element-3013">Total Agregator</p>
            <p className="text-4xl font-extrabold" data-id="element-3014">1</p>
            <p className="text-xs text-violet-200 mt-2" data-id="element-3015">
              PTX (Enterprise Plan)
            </p>
          </div>
        </Card>

        <Card className="p-6 relative overflow-hidden bg-gradient-to-br from-amber-500 to-amber-600 text-white border-0 shadow-xl shadow-amber-200" data-id="element-3016">
          <div className="absolute top-0 right-0 w-32 h-32 opacity-10" data-id="element-3017">
            <Users className="w-full h-full" data-id="element-3018" />
          </div>
          <div className="relative z-10" data-id="element-3019">
            <div className="flex items-center gap-3 mb-3" data-id="element-3020">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-3021">
                <Users className="w-6 h-6 text-white" data-id="element-3022" />
              </div>
              <Badge className="bg-amber-300 text-amber-900 border-0" data-id="element-3023">
                +12
              </Badge>
            </div>
            <p className="text-sm text-amber-100 mb-1" data-id="element-3024">Total Koperasi</p>
            <p className="text-4xl font-extrabold" data-id="element-3025">127</p>
            <p className="text-xs text-amber-200 mt-2" data-id="element-3026">Across all agregators</p>
          </div>
        </Card>
      </div>

      {/* Revenue Share Breakdown */}
      <div className="grid grid-cols-3 gap-6" data-id="element-3027">
        <Card className="p-6 col-span-2" data-id="element-3028">
          <div className="flex items-center justify-between mb-6" data-id="element-3029">
            <div data-id="element-3030">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-3031">
                Revenue Share Breakdown
              </h3>
              <p className="text-sm text-slate-500 mt-1" data-id="element-3032">
                Pembagian pendapatan bulan ini
              </p>
            </div>
            <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-3034" />} data-id="element-3033">
              Export Report
            </Button>
          </div>

          <div className="space-y-4" data-id="element-3035">
            {/* Subscription Fee */}
            <div className="p-4 bg-green-50 border border-green-200 rounded-xl" data-id="element-3036">
              <div className="flex items-center justify-between mb-3" data-id="element-3037">
                <div className="flex items-center gap-3" data-id="element-3038">
                  <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center" data-id="element-3039">
                    <Zap className="w-5 h-5 text-white" data-id="element-3040" />
                  </div>
                  <div data-id="element-3041">
                    <h4 className="font-bold text-slate-900" data-id="element-3042">
                      Subscription Fee
                    </h4>
                    <p className="text-xs text-slate-600" data-id="element-3043">
                      Biaya tetap bulanan
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-3044">
                  <p className="text-2xl font-bold text-green-600" data-id="element-3045">Rp 25Jt</p>
                  <p className="text-xs text-slate-500" data-id="element-3046">100% untuk Platform</p>
                </div>
              </div>
              <div className="w-full h-2 bg-green-200 rounded-full overflow-hidden" data-id="element-3047">
                <div className="h-full bg-green-600 rounded-full" style={{
                width: '100%'
              }} data-id="element-3048"></div>
              </div>
            </div>

            {/* Service Fee */}
            <div className="p-4 bg-blue-50 border border-blue-200 rounded-xl" data-id="element-3049">
              <div className="flex items-center justify-between mb-3" data-id="element-3050">
                <div className="flex items-center gap-3" data-id="element-3051">
                  <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-3052">
                    <Package className="w-5 h-5 text-white" data-id="element-3053" />
                  </div>
                  <div data-id="element-3054">
                    <h4 className="font-bold text-slate-900" data-id="element-3055">Service Fee</h4>
                    <p className="text-xs text-slate-600" data-id="element-3056">
                      Rp 3.500 per transaksi
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-3057">
                  <p className="text-2xl font-bold text-blue-600" data-id="element-3058">Rp 42Jt</p>
                  <p className="text-xs text-slate-500" data-id="element-3059">
                    Total dari 12.000 transaksi
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 mb-2" data-id="element-3060">
                <div className="text-center p-2 bg-white rounded-lg" data-id="element-3061">
                  <p className="text-xs text-slate-500" data-id="element-3062">PTX (60%)</p>
                  <p className="text-lg font-bold text-slate-900" data-id="element-3063">Rp 25,2Jt</p>
                </div>
                <div className="text-center p-2 bg-blue-100 rounded-lg" data-id="element-3064">
                  <p className="text-xs text-blue-700" data-id="element-3065">Platform (40%)</p>
                  <p className="text-lg font-bold text-blue-600" data-id="element-3066">Rp 16,8Jt</p>
                </div>
              </div>
              <div className="w-full h-2 bg-blue-200 rounded-full overflow-hidden flex" data-id="element-3067">
                <div className="h-full bg-slate-400" style={{
                width: '60%'
              }} data-id="element-3068"></div>
                <div className="h-full bg-blue-600" style={{
                width: '40%'
              }} data-id="element-3069"></div>
              </div>
            </div>

            {/* Commission */}
            <div className="p-4 bg-violet-50 border border-violet-200 rounded-xl" data-id="element-3070">
              <div className="flex items-center justify-between mb-3" data-id="element-3071">
                <div className="flex items-center gap-3" data-id="element-3072">
                  <div className="w-10 h-10 bg-violet-600 rounded-lg flex items-center justify-center" data-id="element-3073">
                    <Percent className="w-5 h-5 text-white" data-id="element-3074" />
                  </div>
                  <div data-id="element-3075">
                    <h4 className="font-bold text-slate-900" data-id="element-3076">Komisi (1.5%)</h4>
                    <p className="text-xs text-slate-600" data-id="element-3077">
                      Dari nilai transaksi
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-3078">
                  <p className="text-2xl font-bold text-violet-600" data-id="element-3079">Rp 18Jt</p>
                  <p className="text-xs text-slate-500" data-id="element-3080">Dari GMV Rp 1,2M</p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 mb-2" data-id="element-3081">
                <div className="text-center p-2 bg-white rounded-lg" data-id="element-3082">
                  <p className="text-xs text-slate-500" data-id="element-3083">PTX (70%)</p>
                  <p className="text-lg font-bold text-slate-900" data-id="element-3084">Rp 12,6Jt</p>
                </div>
                <div className="text-center p-2 bg-violet-100 rounded-lg" data-id="element-3085">
                  <p className="text-xs text-violet-700" data-id="element-3086">Platform (30%)</p>
                  <p className="text-lg font-bold text-violet-600" data-id="element-3087">Rp 5,4Jt</p>
                </div>
              </div>
              <div className="w-full h-2 bg-violet-200 rounded-full overflow-hidden flex" data-id="element-3088">
                <div className="h-full bg-slate-400" style={{
                width: '70%'
              }} data-id="element-3089"></div>
                <div className="h-full bg-violet-600" style={{
                width: '30%'
              }} data-id="element-3090"></div>
              </div>
            </div>

            {/* Logistics Margin */}
            <div className="p-4 bg-amber-50 border border-amber-200 rounded-xl" data-id="element-3091">
              <div className="flex items-center justify-between mb-3" data-id="element-3092">
                <div className="flex items-center gap-3" data-id="element-3093">
                  <div className="w-10 h-10 bg-amber-600 rounded-lg flex items-center justify-center" data-id="element-3094">
                    <Truck className="w-5 h-5 text-white" data-id="element-3095" />
                  </div>
                  <div data-id="element-3096">
                    <h4 className="font-bold text-slate-900" data-id="element-3097">
                      Margin Logistik
                    </h4>
                    <p className="text-xs text-slate-600" data-id="element-3098">
                      Selisih tarif logistik
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-3099">
                  <p className="text-2xl font-bold text-amber-600" data-id="element-3100">Rp 24Jt</p>
                  <p className="text-xs text-slate-500" data-id="element-3101">
                    Dari 8.500 pengiriman
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 mb-2" data-id="element-3102">
                <div className="text-center p-2 bg-white rounded-lg" data-id="element-3103">
                  <p className="text-xs text-slate-500" data-id="element-3104">PTX (50%)</p>
                  <p className="text-lg font-bold text-slate-900" data-id="element-3105">Rp 12Jt</p>
                </div>
                <div className="text-center p-2 bg-amber-100 rounded-lg" data-id="element-3106">
                  <p className="text-xs text-amber-700" data-id="element-3107">Platform (50%)</p>
                  <p className="text-lg font-bold text-amber-600" data-id="element-3108">Rp 12Jt</p>
                </div>
              </div>
              <div className="w-full h-2 bg-amber-200 rounded-full overflow-hidden flex" data-id="element-3109">
                <div className="h-full bg-slate-400" style={{
                width: '50%'
              }} data-id="element-3110"></div>
                <div className="h-full bg-amber-600" style={{
                width: '50%'
              }} data-id="element-3111"></div>
              </div>
            </div>
          </div>
        </Card>

        {/* Platform Summary */}
        <div className="space-y-6" data-id="element-3112">
          <Card className="p-6 bg-slate-50 border-slate-200" data-id="element-3113">
            <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-3114">
              Platform Revenue
            </h3>
            <div className="space-y-4" data-id="element-3115">
              <div data-id="element-3116">
                <p className="text-xs text-slate-500 mb-1" data-id="element-3117">Subscription Fee</p>
                <p className="text-2xl font-bold text-green-600" data-id="element-3118">Rp 25,0Jt</p>
              </div>
              <div data-id="element-3119">
                <p className="text-xs text-slate-500 mb-1" data-id="element-3120">Service Fee (40%)</p>
                <p className="text-2xl font-bold text-blue-600" data-id="element-3121">Rp 16,8Jt</p>
              </div>
              <div data-id="element-3122">
                <p className="text-xs text-slate-500 mb-1" data-id="element-3123">Komisi (30%)</p>
                <p className="text-2xl font-bold text-violet-600" data-id="element-3124">Rp 5,4Jt</p>
              </div>
              <div data-id="element-3125">
                <p className="text-xs text-slate-500 mb-1" data-id="element-3126">
                  Margin Logistik (50%)
                </p>
                <p className="text-2xl font-bold text-amber-600" data-id="element-3127">Rp 12,0Jt</p>
              </div>
              <div className="pt-4 border-t border-slate-300" data-id="element-3128">
                <p className="text-sm text-slate-600 mb-1" data-id="element-3129">
                  Total Platform Revenue
                </p>
                <p className="text-3xl font-extrabold text-slate-900" data-id="element-3130">
                  Rp 59,2Jt
                </p>
                <p className="text-xs text-green-600 mt-1" data-id="element-3131">
                  +18% vs bulan lalu
                </p>
              </div>
            </div>
          </Card>

          <Card className="p-6 bg-blue-50 border-blue-200" data-id="element-3132">
            <h3 className="font-bold text-lg text-blue-900 mb-4" data-id="element-3133">
              PTX Revenue
            </h3>
            <div className="space-y-4" data-id="element-3134">
              <div data-id="element-3135">
                <p className="text-xs text-blue-700 mb-1" data-id="element-3136">Service Fee (60%)</p>
                <p className="text-xl font-bold text-blue-900" data-id="element-3137">Rp 25,2Jt</p>
              </div>
              <div data-id="element-3138">
                <p className="text-xs text-blue-700 mb-1" data-id="element-3139">Komisi (70%)</p>
                <p className="text-xl font-bold text-blue-900" data-id="element-3140">Rp 12,6Jt</p>
              </div>
              <div data-id="element-3141">
                <p className="text-xs text-blue-700 mb-1" data-id="element-3142">
                  Margin Logistik (50%)
                </p>
                <p className="text-xl font-bold text-blue-900" data-id="element-3143">Rp 12,0Jt</p>
              </div>
              <div data-id="element-3144">
                <p className="text-xs text-blue-700 mb-1" data-id="element-3145">
                  Margin Barang (100%)
                </p>
                <p className="text-xl font-bold text-blue-900" data-id="element-3146">Rp 15,8Jt</p>
              </div>
              <div className="pt-4 border-t border-blue-300" data-id="element-3147">
                <p className="text-sm text-blue-700 mb-1" data-id="element-3148">Total PTX Revenue</p>
                <p className="text-2xl font-extrabold text-blue-900" data-id="element-3149">
                  Rp 65,6Jt
                </p>
              </div>
            </div>
          </Card>
        </div>
      </div>

      {/* System Health & Performance */}
      <div className="grid grid-cols-3 gap-6" data-id="element-3150">
        <Card className="p-6" data-id="element-3151">
          <div className="flex items-center gap-3 mb-4" data-id="element-3152">
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center" data-id="element-3153">
              <Server className="w-6 h-6 text-green-600" data-id="element-3154" />
            </div>
            <div data-id="element-3155">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-3156">
                System Uptime
              </h3>
              <p className="text-sm text-slate-500" data-id="element-3157">Last 30 days</p>
            </div>
          </div>
          <div className="text-center py-4" data-id="element-3158">
            <p className="text-5xl font-extrabold text-green-600" data-id="element-3159">99.97%</p>
            <p className="text-sm text-slate-600 mt-2" data-id="element-3160">Target: 99.5%</p>
            <Badge variant="success" className="mt-3" data-id="element-3161">
              Excellent
            </Badge>
          </div>
        </Card>

        <Card className="p-6" data-id="element-3162">
          <div className="flex items-center gap-3 mb-4" data-id="element-3163">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center" data-id="element-3164">
              <Activity className="w-6 h-6 text-blue-600" data-id="element-3165" />
            </div>
            <div data-id="element-3166">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-3167">
                API Performance
              </h3>
              <p className="text-sm text-slate-500" data-id="element-3168">Avg response time</p>
            </div>
          </div>
          <div className="text-center py-4" data-id="element-3169">
            <p className="text-5xl font-extrabold text-blue-600" data-id="element-3170">145ms</p>
            <p className="text-sm text-slate-600 mt-2" data-id="element-3171">Target: &lt;200ms</p>
            <Badge variant="success" className="mt-3" data-id="element-3172">
              Optimal
            </Badge>
          </div>
        </Card>

        <Card className="p-6" data-id="element-3173">
          <div className="flex items-center gap-3 mb-4" data-id="element-3174">
            <div className="w-12 h-12 bg-violet-100 rounded-xl flex items-center justify-center" data-id="element-3175">
              <Shield className="w-6 h-6 text-violet-600" data-id="element-3176" />
            </div>
            <div data-id="element-3177">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-3178">
                Security Score
              </h3>
              <p className="text-sm text-slate-500" data-id="element-3179">Last audit</p>
            </div>
          </div>
          <div className="text-center py-4" data-id="element-3180">
            <p className="text-5xl font-extrabold text-violet-600" data-id="element-3181">A+</p>
            <p className="text-sm text-slate-600 mt-2" data-id="element-3182">No critical issues</p>
            <Badge variant="success" className="mt-3" data-id="element-3183">
              Secure
            </Badge>
          </div>
        </Card>
      </div>

      {/* Alerts & Actions */}
      <Card className="p-6" data-id="element-3184">
        <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-3185">
          Platform Alerts & Actions
        </h3>
        <div className="space-y-3" data-id="element-3186">
          <button className="w-full flex items-start gap-3 p-4 bg-green-50 hover:bg-green-100 border border-green-200 rounded-xl transition-colors text-left" data-id="element-3187">
            <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-3188" />
            <div className="flex-1" data-id="element-3189">
              <h4 className="text-sm font-bold text-green-800" data-id="element-3190">
                Subscription Payment Received
              </h4>
              <p className="text-xs text-green-600 mt-1" data-id="element-3191">
                PTX paid Rp 25.000.000 for November 2023
              </p>
            </div>
            <span className="text-xs text-green-600" data-id="element-3192">2 hours ago</span>
          </button>

          <button className="w-full flex items-start gap-3 p-4 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-xl transition-colors text-left" data-id="element-3193">
            <Activity className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-3194" />
            <div className="flex-1" data-id="element-3195">
              <h4 className="text-sm font-bold text-blue-800" data-id="element-3196">
                High Transaction Volume
              </h4>
              <p className="text-xs text-blue-600 mt-1" data-id="element-3197">
                12.000 transactions processed today (+25% vs avg)
              </p>
            </div>
            <span className="text-xs text-blue-600" data-id="element-3198">1 hour ago</span>
          </button>

          <button className="w-full flex items-start gap-3 p-4 bg-amber-50 hover:bg-amber-100 border border-amber-200 rounded-xl transition-colors text-left" data-id="element-3199">
            <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-3200" />
            <div className="flex-1" data-id="element-3201">
              <h4 className="text-sm font-bold text-amber-800" data-id="element-3202">
                Server Load Spike
              </h4>
              <p className="text-xs text-amber-600 mt-1" data-id="element-3203">
                CPU usage reached 75% at peak hours. Consider scaling.
              </p>
            </div>
            <span className="text-xs text-amber-600" data-id="element-3204">3 hours ago</span>
          </button>
        </div>
      </Card>
    </div>;
}